import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Pooja List
export const getPujaList = async () => {
  try {
    const response = await api.get(`${API_URL}/puja/list`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Pooja list:", error);
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Product List
export const getProductList = async () => {
  try {
    const response = await api.get(`${API_URL}/product/list`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Product list:", error);
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Chadawa List
export const getChadawaList = async () => {
  try {
    const response = await api.get(`${API_URL}/chadawa/list`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Chadawa list:", error);
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// get Notification -
export const getNotifications = async (params = {}) => {
  try {
    const response = await api.get(`${API_URL}/notification/history`, {
      params: {
        page: params.page || 1,
        limit: params.limit || 10,
        search: params.search || "",
        startDate: params.startDate || "",
        endDate: params.endDate || "",
        sortOrder: params.sortOrder || "desc",
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch notifications:', error);
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Add Notification - 
// export const addNotification = async (notificationData) => {
//   try {
//     const config = {
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     };
//     const response = await api.post(`${API_URL}/notification/send`, notificationData, config);
//     return response.data;
//   } catch (error) {
//     console.error("Failed to send notification:", error.response?.data || error.message);
//     if (error.response) {
//       console.error("Response status:", error.response.status);
//       console.error("Response data:", error.response.data);
//       console.error("Response headers:", error.response.headers);
//     }
//     handleUnauthorizedOrForbidden(error);
//     throw error;
//   }
// };


export const addNotification = async (notificationData) => {
  try {
    const formData = new FormData();

    // Append all fields
    formData.append("type", notificationData.type);
    formData.append("body", notificationData.body);
    formData.append("title", notificationData.title);
    formData.append("scheduled_at", notificationData.scheduled_at);
    formData.append("target_audience", notificationData.target_audience);

    // Only append image if it's an actual File object
    if (notificationData.image instanceof File) {
      formData.append("image", notificationData.image);
    }

    // Only append type_ref_id if present
    if (notificationData.type_ref_id) {
      formData.append("type_ref_id", notificationData.type_ref_id);
    }

    const response = await api.post(
      `${API_URL}/notification/send`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to send notification:", error.response?.data || error.message);
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};